import React from 'react'
import loadable from '@loadable/component'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

// UI
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils'

// Constants
import {
    PASSWORDLESS_LOGIN_LANDING_PATH,
    RESET_PASSWORD_LANDING_PATH
} from '@salesforce/retail-react-app/app/constants'

const fallback = <Skeleton height="75vh" width="100%" />
const socialRedirectURI = getConfig()?.app?.login?.social?.redirectURI

// General Pages
const Home = loadable(() => import('./pages/home'), {fallback})
const ProductList = loadable(() => import('./pages/product-list'), {fallback})
const ProductDetail = loadable(() => import('./pages/product-detail'), {fallback})
const ContentAsset = loadable(() => import('./pages/content-detail/content-asset'), {fallback})
const SocialLoginRedirect = loadable(() => import('./pages/social-login-redirect'), {fallback})
const WriteReview = loadable(() => import('./pages/write-a-review'), {fallback})
const MyNewRoute = loadable(() => import('./pages/my-new-route'))

// Cart & Checkout
const Cart = loadable(() => import('./pages/cart'), {fallback})
const Checkout = loadable(() => import('./pages/checkout'), {fallback})
const StripePaymentConfirm = loadable(
    () => import('./pages/checkout/stripe/stripe-payment-confirm'),
    {fallback}
)
const DefaultCheckoutConfirmation = loadable(() => import('./pages/checkout/confirmation'), {
    fallback
})

// Account & Auth
const Account = loadable(() => import('./pages/account'), {fallback})
const Registration = loadable(() => import('./pages/registration'), {fallback})
const Login = loadable(() => import('@salesforce/retail-react-app/app/pages/login'), {fallback})
const ResetPassword = loadable(
    () => import('@salesforce/retail-react-app/app/pages/reset-password'),
    {fallback}
)

// Gift Certificate
const GiftCertificate = loadable(() => import('./pages/gift-certificate'), {fallback})

//Wishlist
const AccountWishlist = loadable(() => import('./pages/account/wishlist'), {
    fallback
})
const AccountWishlistItems = loadable(() => import('./pages/account/wishlist/wishlist-items'), {
    fallback
})
const GuestWishlist = loadable(() => import('./pages/guest-wishlist'), {
    fallback
})

const routes = [
    {
        path: '/',
        component: Home,
        exact: true
    },
    {
        path: socialRedirectURI || '/social-callback',
        component: SocialLoginRedirect,
        exact: true
    },
    {
        path: '/my-new-route',
        component: MyNewRoute
    },
    {
        path: '/products/:slug',
        component: ProductDetail
    },
    {
        path: socialRedirectURI || '/social-callback',
        component: SocialLoginRedirect,
        exact: true
    },
    {
        path: '/write-a-review',
        component: WriteReview
    },
    {
        path: '/search',
        component: ProductList
    },
    {
        path: '/collections/:categoryId',
        component: ProductList
    },
    {
        path: '/cart',
        component: Cart,
        exact: true
    },
    {
        path: '/content/:id',
        component: ContentAsset
    },
    {
        path: '/checkout',
        component: Checkout,
        exact: true
    },
    {
        path: '/checkout/stripe-confirm',
        component: StripePaymentConfirm,
        exact: true
    },
    {
        path: '/reset-password' || RESET_PASSWORD_LANDING_PATH,
        component: ResetPassword,
        exact: true
    },
    {
        path: PASSWORDLESS_LOGIN_LANDING_PATH,
        component: Login,
        exact: true
    },
    {
        path: '/login',
        component: Login,
        exact: true
    },
    {
        path: '/giftcertpurchase',
        component: GiftCertificate
    },
    {
        path: '/confirmation/:orderNo',
        component: DefaultCheckoutConfirmation
    },
    {
        path: '/registration',
        component: Registration,
        exact: true
    },
    {
        path: '/account',
        component: Account
    },
    {
        path: '/account/wishlist',
        component: AccountWishlist
    },
    {
        path: '/account/wishlist-items',
        component: AccountWishlistItems
    },
    {
        path: '/guest/wishlist',
        component: GuestWishlist
    }
]

export default () => {
    const config = getConfig()
    return configureRoutes(routes, config, {
        ignoredRoutes: ['/callback', '*']
    })
}
